module.exports = __webpack_public_path__ + "img/calculateur-qt@2x.f5ed299c.png";